import * as React from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";

interface Props {
  modalMessage: string;
  onConfirm: () => void;
  onCancel: (() => void) | (() => void) | null;
  icon?: string;
}

const Modal: React.FC<Props> = ({ modalMessage, onConfirm, onCancel, icon }) => {
  const { t } = useTranslation();

  return (
    <>
      {createPortal(
        <div className="overlay_modal">
          <div className="modal_content">
           {icon && <img src={icon} alt={icon} className="modal_icon"/>}
            <div>{modalMessage}</div>
            <div className={`buttons ${onCancel ? "" : "single_button"}`}>
              <button className="yes" onClick={() => onConfirm()}>
                {onCancel
                  ? t("healthMonitor.modal.yes")
                  : t("healthMonitor.modal.ok")}
              </button>
              {onCancel && (
                <button className="no" onClick={() => onCancel()}>
                  {t("healthMonitor.modal.no")}
                </button>
              )}
            </div>
          </div>
        </div>,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        document.getElementById("root_overlay")!
      )}
    </>
  );
};

export default Modal;
